import {useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {Header, LogoutPopup} from '../../componentsRef'
import {IngresoPromocionTradicionalHeader} from './IngresoPromocionTradicionalHeader'
import {IngresoPromocionTradicionalRightMenu} from './IngresoPromocionTradicionalRightMenu'
import {IngresoPromocionTradicionalTable} from './IngresoPromocionTradicionalTable'
import {traditionalManagementRows, traditionalPromotionMock} from './mockData'
import {TarjetaPFTradicional} from './TarjetaPFTradicional'
import '../../assets/css/IngresoPromocionTradicional.css'

export const IngresoPromocionTradicional = () => {
	const {idPromocion, estadoPromocion} = useParams()
	const navigate = useNavigate()
	const [LogoutState, setLogoutState] = useState(false)
	const [rows, setRows] = useState(traditionalManagementRows)
	const [message, setMessage] = useState('')
	const [selectedProductRow, setSelectedProductRow] = useState(null)

	const setDecision = (rowId, decision) => {
		setRows((currentRows) => currentRows.map((row) => (
			row.id === rowId
				? {...row, decision: row.decision === decision ? null : decision}
				: row
		)))
	}

	const updatePendingRows = (decision) => {
		setRows((currentRows) => currentRows.map((row) => (
			row.decision ? row : {...row, decision}
		)))
	}

	const handleSave = () => {
		setMessage('Cambios mock guardados localmente para la vista tradicional.')
		setTimeout(() => setMessage(''), 3000)
	}

	return (
		<div className='HomeNew IngresoPromocionTradicional'>
			{LogoutState && <LogoutPopup setLogoutState={setLogoutState} />}
			{selectedProductRow && (
				<TarjetaPFTradicional row={selectedProductRow} onClose={() => setSelectedProductRow(null)} />
			)}
			<Header setLogoutState={setLogoutState} />
			<IngresoPromocionTradicionalHeader
				promotion={traditionalPromotionMock}
				idPromocion={idPromocion}
				estadoPromocion={estadoPromocion}
			/>
			<main className='IngresoPromocionTradicionalMain'>
				<section className='traditional-table-panel'>
					<div className='traditional-table-title'>
						<div>
							<h1>Tabla de Gestión Tradicional</h1>
							<p>Mockup basado en la hoja del requerimiento estándar PBOS.</p>
						</div>
						<div className='traditional-title-actions'>
							<button type='button' className='traditional-bulk-approve' onClick={() => updatePendingRows('approved')}>
								Aprobar pendientes
							</button>
							<button type='button' className='traditional-bulk-reject' onClick={() => updatePendingRows('rejected')}>
								Rechazar pendientes
							</button>
						</div>
					</div>
					{message && <div className='traditional-save-message'>{message}</div>}
					<IngresoPromocionTradicionalTable rows={rows} onDecision={setDecision} onOpenProduct={setSelectedProductRow} />
				</section>
			</main>
			<IngresoPromocionTradicionalRightMenu
				onApprovePending={() => updatePendingRows('approved')}
				onRejectPending={() => updatePendingRows('rejected')}
				onSave={handleSave}
				onHome={() => navigate('/HomeNewTraditional')}
			/>
		</div>
	)
}
